import { DialogOptionModel } from '../../Models/DialogOptionModel';
import InputContentChip from './InputContentChip';

type DialogInputContentProps = {
	value: DialogOptionModel | undefined;
};

export default function DialogInputContent({ value }: DialogInputContentProps) {
	if (!value) {
		return null;
	}

	const actionCount = value.Actions?.length || 0;
	const label = value.Description || `Dialog (${actionCount} ${actionCount === 1 ? 'action' : 'actions'})`;

	return <InputContentChip label={label} />;
}
